module.exports = __webpack_public_path__ + "img/CO2.e5e68911.gif";